'use strict';

var Consts = require('consts');
var BaseDeviceSettingsView = require('components/devices/views/common/base_device_settings_view');
var Device = require('models/devices');

var SettingsView = BaseDeviceSettingsView.extend({
    template: require('components/devices/templates/generic_modbus/settings'),

    getInputFields: function () {
        return {
            name: {},
            station: {},
        };
    },

    getUpdatedModel: function (form) {
        return {
            name: form.name,
            station: parseInt(form.station),
        };
    },

    getNewModel: function (form, parent_id, categoryKey) {
        return new Device.Model({
            parent: parseInt(parent_id) || 0,
            name: form.name,
            station: parseInt(form.station) || 0,
            category: categoryKey,
        });
    },
});

module.exports = SettingsView;
